import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'
import {
  parseTicketOrdersSearch,
  type TicketOrdersSearch,
} from '~/features/ticket-orders/lib/order-search'
import { TicketOrdersPage } from '~/features/ticket-orders/ui/ticket-orders-page'
import * as m from '~/paraglide/messages'
import { Button } from '~/shared/ui/button'

export const Route = createFileRoute('/dashboard/events/$eventId/tickets')({
  validateSearch: (search: Record<string, unknown>): TicketOrdersSearch =>
    parseTicketOrdersSearch(search),
  component: EventTickets,
})

function EventTickets() {
  const { eventId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="flex w-full flex-col gap-6">
      <Button asChild variant="ghost" size="sm" className="w-fit">
        <Link to="/dashboard/earnings">
          <ArrowLeft className="h-4 w-4" />
          {m.ticketPageBack()}
        </Link>
      </Button>
      <TicketOrdersPage
        eventId={eventId}
        search={search}
        onSearchChange={(next) => navigate({ search: next, replace: true })}
      />
    </div>
  )
}
